import { DataBean } from "../DataBean";

export class WorkActivityStatuses extends DataBean {

  public async getWorkActivityStatusesCatalogPorPropiedades(properties: any, maxRows?: number): Promise<any> {
    return this.getCustomService(
      "ProcessFlow",
      "java.util.List_getWorkActivityStatusesCatalogPorPropiedades_java.util.Map_Number",
      [properties, maxRows]
    );
  }

  public async deleteWorkActivityStatuses(IDWorkActivityStatuses: number): Promise<any> {
    return this.getCustomService(
      "ProcessFlow",
      "boolean_deleteWorkActivityStatuses_Number",
      [IDWorkActivityStatuses]
    );
  }

  public async updateWorkActivityStatuses(bean: any): Promise<any> {
    return this.getCustomService(
      "ProcessFlow",
      "com.advantage.processflow.bean.WorkActivityStatuses_updateWorkActivityStatuses_com.advantage.processflow.bean.WorkActivityStatuses",
      [
        {
          DataBeanProperties: bean,
          DataBeanName: "com.advantage.processflow.bean.WorkActivityStatuses",
        },
      ]
    );
  }
}
